/**
 * Vue.prototype 原型上的混合
 * @author libaoxu@gaosiedu.com
 */

import { common } from "utils";
// import loading from 'components/loading'
// import PcToast from 'service/comp/toast'
import tracker from "utils/tracker";
import { message, notification, Modal } from "ant-design-vue";
import NAPI from "nadaptor";

/**
 * 因为babel解析问题, 这里得暂存一下, 原因待定
 * @type {Function} _Message
 */
// const _MessageBox = NAPI.ui.MessageBox;
// const _Notification = Notification;

/**
 * 将一些公用方法, 放到Vue.prototype下, 这样在methods参数中可以通过this调用
 * @param Vue Vue方法对象
 */
export default function VueProtoMix(Vue) {
  Object.defineProperties(Vue.prototype, {
    $common: {
      get() {
        return common;
      }
    },

    /**
     * 全局通用loading
     * @return {Object}
     * this.$loading.show() loading展现
     * this.$loading.close() 关闭
     */

    // $loading: {
    //   value: loading
    // },

    /**
     * 统计功能
     */
    $tracker: {
      value: tracker
    }
  });

  // Vue.use(Loading.directive)

  // Vue.prototype.$loading = Loading.service
  // ant-design-vue
  Vue.prototype.$message = message;
  Vue.prototype.$notification = notification;
  Vue.prototype.$info = Modal.info;
  Vue.prototype.$success = Modal.success;
  Vue.prototype.$error = Modal.error;
  Vue.prototype.$warning = Modal.warning;
  Vue.prototype.$confirm = Modal.confirm;
}
